import { createSelector } from '@reduxjs/toolkit';
import { StorageState } from '../../../../reducers';

const sliceSelector = (state: StorageState) => state.users.users.editable;
export const accessEditableUserRulesSelector = () => createSelector(sliceSelector, state => state.accessRules);
export const accessEditableUserSelector = () => createSelector(sliceSelector, state => state.user);
export const accessClienToEditSelector = () => createSelector(sliceSelector, state => state.client);
export const accessClientWithSessionsSelector = () => createSelector(sliceSelector, state => state.clientWithSessions);
